import React from 'react';
import styles from '../SaleReportPage.module.scss';

function PageToggle({ label, pageNum, enabled, onChange, hint, first }) {
  const dividerClasses = [styles.pageDivider];
  if (!enabled) dividerClasses.push(styles.pageDividerOff);
  if (first) dividerClasses.push(styles.pageDividerFirst);

  return (
    <div className={dividerClasses.join(' ')}>
      <span className={styles.pagePill}>PAGE {String(pageNum).padStart(2, '0')}</span>
      <span className={styles.pageTitle}>{label}</span>
      {hint && <span className={styles.pageHint}>{hint}</span>}
      <label className={`${styles.pageDividerToggle} ${enabled ? styles.pageDividerToggleOn : ''}`}>
        <input
          type="checkbox"
          hidden
          checked={enabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className={`${styles.toggleSwitch} ${enabled ? styles.toggleOn : ''}`} />
        <span className={styles.toggleText}>{enabled ? '포함됨' : '제외됨'}</span>
      </label>
    </div>
  );
}

export default PageToggle;
